// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UploadToDtaRequestFilesInner
 */
export interface UploadToDtaRequestFilesInner {
    /**
     * 
     * @type {string}
     * @memberof UploadToDtaRequestFilesInner
     */
    fileName: string;
}

/**
 * Check if a given object implements the UploadToDtaRequestFilesInner interface.
 */
export function instanceOfUploadToDtaRequestFilesInner(value: object): value is UploadToDtaRequestFilesInner {
    if (!('fileName' in value) || value['fileName'] === undefined) return false;
    return true;
}

export function UploadToDtaRequestFilesInnerFromJSON(json: any): UploadToDtaRequestFilesInner {
    return UploadToDtaRequestFilesInnerFromJSONTyped(json, false);
}

export function UploadToDtaRequestFilesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadToDtaRequestFilesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'fileName': json['fileName'],
    };
}

export function UploadToDtaRequestFilesInnerToJSON(json: any): UploadToDtaRequestFilesInner {
    return UploadToDtaRequestFilesInnerToJSONTyped(json, false);
}

export function UploadToDtaRequestFilesInnerToJSONTyped(value?: UploadToDtaRequestFilesInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fileName': value['fileName'],
    };
}
